import { Navigate } from 'react-router';
import jwt from 'jwtservice/jwtService';

export default function PermissionGuard({ permission, children }) {
    if (!permission || jwt.hasPermission(permission)) return children;
    return <Navigate to="/dashboard" replace />;
}
